export const IconShowEye: {
  name: 'icon_show_eye-009c747e3b6e'
} = {
  name: 'icon_show_eye-009c747e3b6e'
}
